var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "svg",
    {
      attrs: {
        xmlns: "http://www.w3.org/2000/svg",
        width: "16",
        height: "17",
        viewBox: "0 0 16 17",
        fill: "none",
      },
    },
    [
      _c("g", { attrs: { "clip-path": "url(#clip0_721_8368)" } }, [
        _c("path", {
          attrs: {
            d: "M8.00016 14.5C12.4189 14.5 16.0002 11.5906 16.0002 8C16.0002 4.40937 12.4189 1.5 8.00016 1.5C3.58141 1.5 0.000158712 4.40937 0.000158712 8C0.000158712 9.40938 0.553284 10.7125 1.49078 11.7781C1.43141 12.5437 1.13453 13.225 0.822034 13.7437C0.650159 14.0312 0.475159 14.2625 0.347034 14.4187C0.281409 14.4969 0.231409 14.5563 0.193909 14.5969C0.175159 14.6156 0.162659 14.6313 0.153284 14.6406L0.143909 14.65C0.000158712 14.7937 -0.0404663 15.0063 0.0376587 15.1938C0.115784 15.3813 0.297034 15.5031 0.500159 15.5031C1.39703 15.5031 2.30016 15.225 3.05016 14.9C3.76578 14.5875 4.37516 14.2156 4.74703 13.9438C5.74078 14.3031 6.84078 14.5031 8.00016 14.5031V14.5ZM4.00016 7C4.26538 7 4.51973 7.10536 4.70727 7.29289C4.8948 7.48043 5.00016 7.73478 5.00016 8C5.00016 8.26522 4.8948 8.51957 4.70727 8.70711C4.51973 8.89464 4.26538 9 4.00016 9C3.73494 9 3.48059 8.89464 3.29305 8.70711C3.10552 8.51957 3.00016 8.26522 3.00016 8C3.00016 7.73478 3.10552 7.48043 3.29305 7.29289C3.48059 7.10536 3.73494 7 4.00016 7ZM8.00016 7C8.26538 7 8.51973 7.10536 8.70726 7.29289C8.8948 7.48043 9.00016 7.73478 9.00016 8C9.00016 8.26522 8.8948 8.51957 8.70726 8.70711C8.51973 8.89464 8.26538 9 8.00016 9C7.73494 9 7.48059 8.89464 7.29305 8.70711C7.10552 8.51957 7.00016 8.26522 7.00016 8C7.00016 7.73478 7.10552 7.48043 7.29305 7.29289C7.48059 7.10536 7.73494 7 8.00016 7ZM11.0002 8C11.0002 7.73478 11.1055 7.48043 11.2931 7.29289C11.4806 7.10536 11.7349 7 12.0002 7C12.2654 7 12.5197 7.10536 12.7073 7.29289C12.8948 7.48043 13.0002 7.73478 13.0002 8C13.0002 8.26522 12.8948 8.51957 12.7073 8.70711C12.5197 8.89464 12.2654 9 12.0002 9C11.7349 9 11.4806 8.89464 11.2931 8.70711C11.1055 8.51957 11.0002 8.26522 11.0002 8Z",
            fill: "white",
          },
        }),
      ]),
      _c("defs", [
        _c("clipPath", { attrs: { id: "clip0_721_8368" } }, [
          _c("rect", {
            attrs: {
              width: "16",
              height: "16",
              fill: "white",
              transform: "translate(0 0.5)",
            },
          }),
        ]),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }